import { uploadFileErrorMessage } from "common/consts/uploadFileErrors";
import { Button } from "components/button/Button";
import Modal from "components/modal/Modal";

import "./FileUploadErrorModal.scss"

export type Props = {
  failMessage: string;
  setFailed: (failed: boolean) => void;
};

export default function FileUploadErrorModal({ failMessage, setFailed }) {
  const errorMessage = uploadFileErrorMessage[failMessage];

  return (
    <Modal
      size="xs"
      onDismiss={() => setFailed(false)}
      modalTitle="upload failed"
      header={<h1 className="m-0">{errorMessage.title}</h1>}
      footer={
        <div className="text-right">
          <Button color={"tertiary"} onClick={() => setFailed(false)}>
            Fortsätt
          </Button>
        </div>
      }
    >
      <p className="file-error-message">{errorMessage.message}</p>
    </Modal>
  );
}
